<template>
<!--内容管理-->
  <div id="articleManage" style="padding-bottom: 10px">
    <div class="allMenuHead">
        <!-- v-if="$childMenu.indexOf('文章配置') >= 0"  -->
      <div :class="step === 1 ? 'active' : ''" @click="toUrl('takedaArticleManage', 1)" v-if="$childMenu.indexOf('文章集锦轮播图') >= 0" class="d_i headTab p_r">文章集锦轮播图配置<div class="p_a"></div></div>
      <div :class="step === 2 ? 'active' : ''" @click="toUrl('takedaCountyManage', 2)" v-if="$childMenu.indexOf('县域轮播图') >= 0" class="d_i headTab p_r">县域轮播图配置<div class="p_a"></div></div>
    </div>
    <div class="allHeaderRouter">
      <transition name="fadeLeft">
        <router-view></router-view>
      </transition>
    </div>
  </div>
</template>

<script>
let Time
let reflashTime
export default {
  name: 'articleManage',
  data () {
    return {
      step: 1,
      ContentReleaseNumber: '',
      UnReviewCount: '',
      size: 1,
      showMenu: true,
      appowner: JSON.parse(window.sessionStorage.getItem('nowApp')),
      isAdmin: window.localStorage.getItem('isAdmin')
    }
  },
  created () {
    console.log("tttttttttttttt:",this.$childMenu)
    if (window.screen.width < 1400) {
      this.size = 0.92
    }
    console.log(this.size)
    Time = setInterval(p => {
      if (window.location.href.indexOf('takedaArticleManage') >= 0) {
        this.step = 1
      } else if (window.location.href.indexOf('takedaCountyManage') >= 0) {
        this.step = 2
      }
    }, 100)
    reflashTime = setInterval(p => {
      let data = window.sessionStorage.getItem('reflash')
      if (data === 'need') {
        window.sessionStorage.setItem('reflash', '')
      }
    }, 100)
  },
  destroyed () {
    clearInterval(Time)
    clearInterval(reflashTime)
  },
  methods: {
    toUrl (url, num) {
      this.step = num
      this.$router.push(url)
    }
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/pages/articleManage/articleManage.vue